export default {"src":"/_next/static/image/public/images/flags/flag_357.4ab5a693f1a5bc1372e8e97d3d2aa58a.svg","height":16,"width":24};